import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import {
  Container, Button, Form, Modal 
} from "react-bootstrap";
import ReactCodeInput from 'react-verification-code-input';
import FocusTrap from "focus-trap-react";
import http from "../../api/http-request";
import CloseIcon from "../../assets/images/close-icon.svg";
import {
  pageNotFound
} from "../../utils/common";

class VerifyEmailAddressPopup extends Component {
  constructor(props) {
    super(props);
    this.emailAddressInputRef = React.createRef();
    this.verificationInputRef = React.createRef();
    this.state = {
      verificationCode: "",
      screen: 1,
      mail:props.mail,
      verificationPlaceholder:['0', '0', '0', '0', '0', '0', '0', '0']
    };
  }
  
  componentDidMount() {
    this.getOtp();
  }

  getOtp = () => {
    const { mail } = this.state;
    const dataStoreToken = localStorage.getItem("authToken");
    const { onErrorHandler } = this.props;
    const bearer = 'Bearer ';
   
    http(
      {
        url: "endpoint/emailVerification?_action=generateOtp",
        method: "POST",
        data: {
          mail
        }
      },
      {
        "X-OpenIDM-OAuth-Login": true,
        "X-Requested-With": "XMLHttpRequest",
        Authorization: `${bearer}${dataStoreToken}`
      }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data.code === 200) {
        this.setState({
          screen: 2
        });
      } else if (
        res.status === 403 &&
        res.data.message.includes("Not a valid phone number")
      ) {
        this.setState({
          emailError: "pages.editEmailAddressPopup.emailAddressInvalid"
        });
        this.mobileNumberInputRef.current.focus();
      } else if (res.status === 200 && res.data && typeof res.data === 'string') {
        pageNotFound(res);
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "INVALID_NUMBER") {
        this.setState({
          emailError: "pages.editEmailAddressPopup.invalidEmailAddress"
        });
      } else if (res.status === 401 && res.data.code === 401 && res.data.message === "SEND_OTP_FAILED") {
        this.setState({
          emailError: "pages.editEmailAddressPopup.sendOTPFailed"
        });
      } else if (res.status === 404 && res.data.code === 404 && res.data.message === "REQUESTED_RESOURCE_NOT_FOUND") {
        this.setState({
          emailError: "pages.editNumberPopup.requestedResourceNotFound"
        });
      } else if (res.status === 403 && res.data.code === 403 && res.data.message === "UNKNOWN_ERROR") {
        this.setState({
          emailError: "pages.editNumberPopup.unknownError"
        });
      } else if (res.status === 502 && res.data.code === 502 && res.data.message === "SMTP_ERROR") {
        onErrorHandler("error", res.data.message);
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "MAX_RESEND_EXCEEDED") {
        onErrorHandler("error", res.data.message);
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "MAX_RETRY_EXCEEDED") {
        onErrorHandler("error", res.data.message);
      }
    });
  };

  getResendOtp = () => {
    const { mail } = this.state;
    const dataStoreToken = localStorage.getItem("authToken");
    const { onErrorHandler } = this.props;
    this.verificationInputRef.current.__clearvalues__();
    this.setState({
      verificationCode:"",
      verificationCodeError:""
    });
   
    http(
      {
        url: "endpoint/emailVerification?_action=resendOtp",
        method: "POST",
        data: {
          mail
        }
      },
      {
        "X-OpenIDM-OAuth-Login": true,
        "X-Requested-With": "XMLHttpRequest",
        "X-OpenIDM-DataStoreToken": dataStoreToken
      }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data.code === 200) {
        this.setState({
          screen: 2
        });
      } else if (
        res.status === 403 &&
        res.data.message.includes("Not a valid phone number")
      ) {
        this.setState({
          emailError: "pages.editEmailAddressPopup.emailAddressInvalid"
        });
        this.mobileNumberInputRef.current.focus();
      } else if (res.status === 200 && res.data && typeof res.data === 'string') {
        pageNotFound(res);
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "INVALID_NUMBER") {
        this.setState({
          emailError: "pages.editEmailAddressPopup.invalidEmailAddress"
        });
      } else if (res.status === 401 && res.data.code === 401 && res.data.message === "SEND_OTP_FAILED") {
        this.setState({
          emailError: "pages.editEmailAddressPopup.sendOTPFailed"
        });
      } else if (res.status === 404 && res.data.code === 404 && res.data.message === "REQUESTED_RESOURCE_NOT_FOUND") {
        this.setState({
          emailError: "pages.editNumberPopup.requestedResourceNotFound"
        });
      } else if (res.status === 403 && res.data.code === 403 && res.data.message === "UNKNOWN_ERROR") {
        this.setState({
          emailError: "pages.editNumberPopup.unknownError"
        });
      } else if (res.status === 502 && res.data.code === 502 && res.data.message === "SMTP_ERROR") {
        onErrorHandler("error", res.data.message);
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "MAX_RESEND_EXCEEDED") {
        onErrorHandler("error", res.data.message);
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "MAX_RETRY_EXCEEDED") {
        onErrorHandler("error", res.data.message);
      }
    });
  };

  onVerify = (e) => {
    e.preventDefault();
    const { verificationCode } = this.state;
    const { onVerifyEmailAddressHandler, onErrorHandler } = this.props;
    if (verificationCode === "") {
      this.setState({
        verificationCodeError: "pages.editNumberPopup.verificationCodeRequired"
      });
    } else {
      this.verificationInputRef.current.__clearvalues__();
      const dataStoreToken = localStorage.getItem("authToken");
      this.setState({
        verificationCodeError: ""
      });
      const bearer = 'Bearer ';
      http(
        {
          url: "endpoint/emailVerification?_action=validateOtp",
          method: "POST",
          data: {
            otp: verificationCode
          }
        },
        {
          "X-OpenIDM-OAuth-Login": true,
          "X-Requested-With": "XMLHttpRequest",
          Authorization: `${bearer}${dataStoreToken}`
        }
      ).then((res) => {
        if (res.status === 200 && res.data && res.data.code === 200) {
          onVerifyEmailAddressHandler("success");
        } else if (
          res.status === 400 &&
          res.data.message === "Please enter valid OTP"
        ) {
          this.setState({
            verificationCodeError: "pages.editNumberPopup.verificationCodeError"
          });
        } else if (res.status === 200 && res.data && typeof res.data === 'string') {
          pageNotFound(res);
        } else if (res.status === 400 && res.data.code === 400 && res.data.message === "CONTENT_REQUIRED") {
          this.setState({
            verificationCodeError: "pages.editEmailAddressPopup.contentRequired"
          });
        } else if (res.status === 400 && res.data.code === 400 && res.data.message === "ACTION_REQUIRED") {
          this.setState({
            verificationCodeError: "pages.editEmailAddressPopup.actionRequired"
          });
        } else if (res.status === 400 && res.data.code === 400 && res.data.message === "OTP_REQUIRED") {
          this.setState({
            verificationCodeError: "pages.editEmailAddressPopup.otpRequired"
          });
        } else if (res.status === 400 && res.data.code === 400 && res.data.message === "OTP_INVALID") {
          this.setState({
            verificationCodeError: "pages.editEmailAddressPopup.invalidOTP"
          });
        } else if (res.status === 400 && res.data.code === 400 && res.data.message === "OTP_EXPIRED") {
          this.setState({
            verificationCodeError: "pages.editEmailAddressPopup.expiredOTP"
          });
        } else if (res.status === 502 && res.data.code === 502 && res.data.message === "SMTP_ERROR") {
          onErrorHandler("error", res.data.message);
        } else if (res.status === 400 && res.data.code === 400 && res.data.message === "MAX_RESEND_EXCEEDED") {
          onErrorHandler("error", res.data.message);
        } else if (res.status === 400 && res.data.code === 400 && res.data.message === "MAX_RETRY_EXCEEDED") {
          onErrorHandler("error", res.data.message);
        } else {
          onVerifyEmailAddressHandler("error");
        }
      });
    }
  };

  handleChange = (vals) => {
    this.setState({
      verificationCode:vals
    })
  };

  render() {
    const { t, onClose } = this.props;
    const {
      verificationCodeError,
      mail, verificationPlaceholder
    } = this.state;

    return (
      <Modal
        show
        animation={false}
        onEscapeKeyDown={() => onClose()}
        aria-labelledby="mobile-modal"
      >
        <FocusTrap>
          <div className="popup change-mobile-number">
            <Container fluid>
              <div className="popup__wrapper">
                <Form>
                  <div className="popup__wrapper-body">
                    <div className="popup__wrapper-body-header">
                      <h6 id="mobile-modal">
                        {t("pages.editEmailAddressPopup.verifyEmailAddress")}
                      </h6>
                      <Button
                        className="popup__wrapper-body-header-close"
                        onClick={() => {
                          onClose();
                        }}
                        variant="light"
                        aria-label="Close"
                      >
                        <img src={CloseIcon} alt="" />
                      </Button>
                    </div>

                    <div className="popup__wrapper-body-resend">
                      <p>
                        {t("pages.editNumberPopup.enterTheVerificationText")}
                        <br />
                        {mail}
                      </p>
                      <p
                        className="popup__wrapper-body-resend-btn"
                        onClick={() => this.getResendOtp()}
                        role="button"
                        tabIndex={0}
                      >
                        {t("pages.editNumberPopup.resendVerificationCode")}
                      </p>
                    </div>
                    <Form.Group controlId="verificationCode">
                      <Form.Label>
                        {t("pages.editNumberPopup.verificationCode")}
                      </Form.Label>
                      <ReactCodeInput
                        fields={8}
                        ref={this.verificationInputRef}
                        placeholder={verificationPlaceholder}
                        className={`verification-input
                            ${verificationCodeError ? "error-verification" : undefined}`}
                        onChange={this.handleChange}
                        removeDefaultStyles
                        autoFocus={false}
                      />
                    </Form.Group>
                    {verificationCodeError && (
                      <p className="error-text" id="verification-error">
                        {verificationCodeError && t(verificationCodeError)}
                      </p>
                    )}      
                  </div>
                  <div className="popup__wrapper-footer">
                    <Button
                      className="wrapper__container-card-body-submit"
                      size="lg"
                      variant="primary"
                      block
                      type="submit"
                      onClick={(e) => this.onVerify(e)}
                    >
                      {t("pages.editNumberPopup.verify")}
                    </Button> 
                  </div>
                </Form>
              </div>
            </Container>
          </div>
        </FocusTrap>
      </Modal>
    );
  }
}

VerifyEmailAddressPopup.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onVerifyEmailAddressHandler: PropTypes.func.isRequired,
  onErrorHandler: PropTypes.func.isRequired,
  mail: PropTypes.string
};

VerifyEmailAddressPopup.defaultProps = {
  mail: ""
};
export default withTranslation()(VerifyEmailAddressPopup);
